export const m = {
	new_txt1:'未登录只能查看3条记录',
	new_txt2:'立即登录',
	new_txt3:'暂无数据',
	new_txt4:'无',
	
	order_state1:'待报价',
	order_state_txt1:'请耐心等待业务员联系您报价',
	
	order_state2:'待付款',
	order_state_txt2:'请联系业务员进行付款',
	
	order_state3:'待发货',
	order_state_txt3:'请耐心等待仓库进行发货',
	
	order_state4:'待收货',
	order_state_txt4:'请耐心等待仓库进行发货',
	
	order_state5:'已取消',
	
	order_state6:'已收货',
	order_state_txt6:'感谢您的支持',
	
	zw_txt1:'暂无收货地址，快去添加吧',
	zw_txt2:'暂无我的消息',
	zw_txt3:'暂无帮助中心',
	zw_txt4:'暂无我的订单',
	
	
	shoping_txt1:'商品',
	
	
	wl_tit:'物流列表',
	wl_txt1:'发货时间',
	wl_txt2:'配送方式',
	wl_txt3:'发货单号',
	wl_txt4:'发货商品',
	wl_txt5:'查看',
	wl_txt6:'发货商品',
	
	
	title: 'Taiqiu123 | 台球批发超市 | 台球器材 | 台球杆 | 台球桌 | 台球配件',
	is_en: 'false',
	home_012: "请先注册",
	home_011: "授权失败",
	home_01: "搜索",
	home_02: "品牌",
	home_03: "产品",
	home_033: "操作说明",
	home_04: "联系我们",
	home_05: "列表",
	home_06: "新闻",
	home_07: "产品",
	home_08: "联系",
	home_09: "我们",
	home_10: "请输入商品关键词",
	home_11: "查看详情",
	home_12: "地址",
	home_13: "电话",
	home_14: "邮箱",
	home_15: "姓名",
	home_16: "内容",
	home_17: "发布时间",
	home_18: "提交",
	home_19: "提交成功！",
	userhome_01: '未付款订单数',
	userhome_02: '已付款金额',
	userhome_03: '客服联系方式',
	userhome_04: '订单数走势图',
	userhome_05: '订单金额(已付款)走势图',
	userinfo_01: "头像",
	userinfo_02: "修改头像",
	userinfo_03: "昵称",
	userinfo_04: "公司名称",
	userinfo_05: "公司税号",
	userinfo_06: "编辑资料",
	userinfo_07: "您的账号审核被驳回，请查看原因修改",
	userinfo_077: "您的账号正在审核中，审核时间约1-3个工作日，请耐心等待",
	userinfo_08: "查看原因",
	userinfo_09: "提交审核",
	userinfo_10: "审核期间无法修改资料",
	userinfo_11: "公司营业执照",
	userinfo_12: "上传图片",
	userinfo_13: "用户身份",
	userinfo_133: "登录方式",
	userinfo_134: "邮箱",
	userinfo_135: "电话",
	userinfo_14: "用户身份标签",
	userinfo_15: "保存",
	userinfo_16: "请输入昵称",
	userinfo_17: "请输入邮箱",
	userinfo_18: "请输入电话",
	userinfo_19: "请输入公司名称",
	userinfo_20: "请输入公司税号",
	userinfo_21: "个人",
	userinfo_22: "企业",
	userinfo_23: "绑定第三方",
	userinfo_24: "授权绑定",
	userinfo_245: "已绑定",
	userinfo_25: "驳回原因",
	userinfo_26: "好的",
	userinfo_27: "请输入手机号",
	userinfo_28: "请上传公司营业执照",
	userinfo_29: "修改成功",
	MallCenter_01: '商城中心',
	MallCenter_02: '分类',
	MallCenter_03: '品牌',
	MallCenter_04: '共',
	MallCenter_05: ' 条',
	MallCenter_06: '请输入商品关键词进行搜索',
	MallCenter_07: '序号',
	MallCenter_08: '商品图',
	MallCenter_09: '商品名称',
	MallCenter_10: '商品类型',
	MallCenter_11: '品牌',
	MallCenter_12: '型号',
	MallCenter_13: '单价(人民币)',
	MallCenter_14: '单价(美金)',
	MallCenter_15: '操作',
	MallCenter_16: '展开',
	MallCenter_17: '收起',
	MallCenter_18: '立即下单',
	MallCenter_19: '商品详情',
	MallCenter_20: '全部',
	MallCenter_21: '请输入商品关键词',
	MallCenter_22: '请先登录',
	MallCenter_23: '请至少选择一件商品下单',
	MallCenter_24: '当前商品库存不足',
	MallCenter_25: '首页',
	MallCenter_26: '搜索结果',
	Myorder_01: '我的订单',
	Myorder_02: '待报价',
	Myorder_03: '待付款',
	Myorder_04: '待发货',
	Myorder_05: '待收货',
	Myorder_06: '已收货',
	Myorder_07: '下载',
	Myorder_08: '订单编号',
	Myorder_09: '商品名称',
	Myorder_10: '购买规格',
	Myorder_11: '购买数量',
	Myorder_12: '下单时间',
	Myorder_122: '取消时间',
	Myorder_1222: '报价时间',
	Myorder_12222: '发货时间',
	Myorder_13: '订单状态',
	Myorder_14: '待报价',
	Myorder_15: '待付款',
	Myorder_16: '待发货',
	Myorder_17: '待收货',
	Myorder_18: '已取消',
	Myorder_19: '已完成',
	Myorder_20: '已收货',
	address_01: '我的收货地址',
	address_02: '新添加收货地址',
	address_03: '编辑',
	address_04: '删除',
	address_05: '收货人姓名',
	address_06: '收货人电话',
	address_07: '详细地址',
	address_08: '返回',
	address_09: '请输入收货人姓名',
	address_10: '请输入收货人电话',
	address_11: '请输入详细地址',
	address_12: '提示',
	address_13: '是否确认删除该地址',
	address_14: '确认删除',
	address_15: '创建收货地址',
	address_16: '确认新增',
	address_17: '切换默认地址成功',
	address_18: '编辑收货地址',
	address_19: '确认编辑',
	address_20: '请输入姓名',
	address_21: '请输入手机号',
	address_22: '请输入详细地址',
	address_23: '创建成功！',
	address_24: '编辑成功！',
	address_25: '删除成功！',
	RetrievePWD_01: '找回密码',
	RetrievePWD_02: '设置新密码',
	RetrievePWD_03: '再输入一次密码',
	RetrievePWD_04: '立即找回',
	RetrievePWD_05: '请输入新密码',
	RetrievePWD_06: '请再次输入新密码',
	RetrievePWD_07: '恭喜您找回密码成功',
	RetrievePWD_08: '两次密码输入不一致',
	index_01: '主页',
	index_02: '个人信息',
	index_03: '商城中心',
	index_04: '我的订单',
	index_05: '收货地址',
	index_06: '找回密码',
	index_07: '我的消息',
	index_08: '帮助中心',
	index_09: '退出登录',
	index_10: '是否确认退出登录？',
	index_11: '确认退出',
	index_12: '返回主页',
	index_13: '登入/注册',
	PlaceOrder_01: '返回上一页',
	PlaceOrder_02: '确认需求订单',
	PlaceOrder_03: '订单备注',
	PlaceOrder_04: '请输入订单备注',
	PlaceOrder_05: '订单总价',
	PlaceOrder_06: '收货人',
	PlaceOrder_066: '暂无收货地址信息',
	PlaceOrder_07: '规格项',
	PlaceOrder_08: '数量',
	PlaceOrder_09: '总价(人民币)',
	PlaceOrder_10: '总价(美元)',
	PlaceOrder_099: '单价(人民币)',
	PlaceOrder_100: '单价(美元)',
	PlaceOrder_11: '选择收货地址',
	PlaceOrder_12: '请选择',
	Submit_01: '订单提交成功',
	Submit_02: '请耐心等待业务员联系您',
	Submit_03: '继续购买',
	Submit_04: '查看订单详情',
	order_info_01: '确认收货',
	order_info_02: '取消订单',
	order_info_03: '下载',
	order_info_04: '订单信息',
	order_info_05: '费用(人民币)',
	order_info_06: '费用(美金)',
	order_info_07: '请收到商品并检查无误后，再确认收货',
	order_info_08: '是否取消订单',
	order_info_09: '确认取消',
	order_info_10: '收货成功',
	order_info_11: '取消订单成功',
	login_01: '登入',
	login_02: '还没有账户',
	login_03: '立即注册',
	login_04: '电子邮箱',
	login_044: '手机号',
	login_05: '密码',
	login_06: '忘记密码了吗？',
	login_07: '以',
	login_08: '继续',
	login_09: '请输入邮箱账号',
	login_10: '请输入密码',
	login_11: '登入即表示您同意',
	login_12: '使用條款',
	login_13: '願意收取 哈芙游乐的電子郵件和最新資訊，並已閱讀',
	login_14: '隱私權政策',
	login_15: '登陆成功，即将跳转到首页',
	register_01: '注册',
	register_02: '已有一个账号',
	register_03: '绑定电子邮箱',
	register_04: '验证码',
	register_05: '再次输入密码',
	register_06: '获取验证码',
	register_07: '上传营业执照',
	register_08: '请输入绑定电子邮箱',
	register_088: '请输入手机号',
	register_09: '请输入验证码',
	register_10: '请再次输入密码',
	register_11: '公司',
	register_12: '验证码已发送至您的邮箱',
	registerSuccess_01: '恭喜您',
	registerSuccess_02: '成功',
	registerSuccess_03: '去登入',
	RetrievePwd_01: '请输入电子邮箱',
	RetrievePwd_02: '请输入绑定的电子邮箱账号'
}
